import _ from 'lodash'
import Action from 'src/models/Action'
import ActionType from 'src/models/ActionType'
import Activity from 'src/models/Activity'
import BodyArea from 'src/models/BodyArea'
import Equipment from 'src/models/Equipment'
import Goal from 'src/models/Goal'
import {RootState} from './rootReducer'

export const ActionSelectors = {
  selectActions: (state: RootState) => _.values(state.actions.actions) as Action[],
}

export const bodyAreasSelectors = {
  selectBodyAreas: (state: RootState) => _.values(state.bodyAreas.bodyAreas) as BodyArea[],
}

export const equipmentSelectors = {
  selectEquipment: (state: RootState) => _.values(state.equipment.equipment) as Equipment[],
}

export const actionTypesSelectors = {
  selectActionTypes: (state: RootState) => _.values(state.actionTypes.actionTypes) as ActionType[],
}

export const ActivitySelectors = {
  selectActivities: (state: RootState) => _.values(state.activities.activities) as Activity[],
}

export const GoalSelectors = {
  selectGoals: (state: RootState) => _.values(state.goals.goals) as Goal[],
}
